import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Heart, Brain, Target } from 'lucide-react';
import { HealthMetrics } from '../../types/health';

interface StrainMetricsProps {
  metrics: HealthMetrics;
}

export function StrainMetrics({ metrics }: StrainMetricsProps) {
  const metricCards = [
    {
      title: 'Current Strain',
      value: metrics.strain.current.toFixed(1),
      icon: <Activity className="w-4 h-4" />,
      change: metrics.strain.change,
      status: metrics.strain.current < metrics.strain.optimal.max ? 'success' : 'warning'
    },
    {
      title: 'Recovery',
      value: `${metrics.recovery}%`,
      icon: <Heart className="w-4 h-4" />,
      change: 5,
      status: metrics.recovery > 70 ? 'success' : 'warning'
    },
    {
      title: 'Readiness',
      value: `${metrics.readiness}%`,
      icon: <Brain className="w-4 h-4" />,
      change: 3,
      status: metrics.readiness > 70 ? 'success' : 'warning'
    },
    {
      title: 'Target Range',
      value: `${metrics.strain.optimal.min}-${metrics.strain.optimal.max}`,
      icon: <Target className="w-4 h-4" />,
      status: 'info'
    }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {metricCards.map((card, index) => (
        <motion.div
          key={card.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              {card.icon}
              <span>{card.title}</span>
            </div>
            <div className="text-2xl font-bold">{card.value}</div>
            {card.change && (
              <div className={`flex items-center gap-1 text-xs ${
                card.status === 'success' ? 'text-success' : 'text-warning'
              } mt-1`}>
                <Activity className="w-3 h-3" />
                <span>{card.change > 0 ? '+' : ''}{card.change}% vs yesterday</span>
              </div>
            )}
          </div>
        </motion.div>
      ))}
    </div>
  );
}